import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { NodeComponent } from './node/node.component';
import { FilesService } from '../../../services/files.service';
import { FileSystemNode, NodeClass } from '../../../model/FileSystemNode';
import { DialogService } from '../../../services/dialog.service';
import { NodeOperationResult } from '../../../model/NodeOperationResult';


@Component({
  selector: 'app-files',
  imports: [CommonModule, NodeComponent],
  templateUrl: './files.component.html',
  styleUrl: './files.component.scss'
})
export class FilesComponent {
  public root: FileSystemNode;
  private dialogService = inject(DialogService);

  constructor(private service: FilesService) {
    this.root = new NodeClass({});
  }

  findRecursive(children: FileSystemNode[], event: FileSystemNode): FileSystemNode | undefined {
    let node;
    for (let i = 0; i < children.length; i++) {
      if (children[i].path === event.path)
        node = children[i];
    }
    if (!node) {
      for (let i = 0; i < children.length; i++) {
        if (children[i].children) {
          node = this.findRecursive(children[i].children, event);
        }
        if (node) {
          break;
        }
      }
    }
    return node;
  }

  deleteRecursive(children: FileSystemNode[], event: FileSystemNode): void {
    let deleted = false;
    for (let i = 0; i < children.length; i++) {
      if (children[i].path === event.path) {
        children[i].deleted = true;
        deleted = true;
        break;
      }
    }
    if (!deleted) {
      for (let i = 0; i < children.length; i++) {
        if (children[i].children) {
          this.deleteRecursive(children[i].children, event);
        }
      }
    }
  }

  /**
   * Procesa las diferentes operaciones con los nodos del arbol de directorios.
   * @param data el nodo al cual le aplicamos la accion
   */
  processNodeOperation(data: NodeOperationResult | boolean) {
    let node;
    let type = '';
    let dataNode: FileSystemNode = new NodeClass({});
    let addedNode: FileSystemNode | undefined = new NodeClass({});
    // todo: esto es una mala practica, hacer que sea de solo un tipo data, corregir.
    if (typeof data !== 'boolean') {
      type = data.type;
      dataNode = data.node;
      addedNode = data.addedNode;
    }
    switch (type) {
      case 'added':
        node = this.findRecursive(this.root.children, dataNode) || { children: [] };
        node.children = (addedNode || { children: [] }).children;
        break;
      case 'created':
        if (!dataNode.isRoot) {
          node = this.findRecursive(this.root.children, dataNode);
        } else {
          node = dataNode;
        }
        if (node && addedNode) {
          node.children.push(addedNode);
        }
        break;
      case 'edited':
        node = this.findRecursive(this.root.children, dataNode);
        if (node && addedNode) {
          node.name = addedNode.name;
        }
        break;
      case 'deleted':
        this.service.deleteItem(dataNode).subscribe({
          next: () => {
            this.deleteRecursive(this.root.children, dataNode);
          },
          error: () => {
            alert('hubo un error eliminando el nodo');
          }
        });
        break;
    }
  }

  agregarDirectorio(node: FileSystemNode) {
    this.dialogService.agregarDirectorio(node).subscribe(result => {
      this.processNodeOperation(result);
    });
  }

  ngOnInit(): void {
    this.service.getDirectory('.').subscribe(node => {
      this.root = node;
      this.root.opened = true;
      this.root.isRoot = true;
    });
  }

}
